import axios, { AxiosResponse, AxiosError } from "axios";
import {  toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getAuthToken } from '../../Utils/auth.ts';

let isUnauthorizedHandled = false;
let isServerErrorHandled = false;

const handleUnauthorized = () => {
  if (isUnauthorizedHandled) return;
  isUnauthorizedHandled = true;

  localStorage.clear();
  toast.error("Login Expired.");

  if ((window as any).ReactNativeWebView) {
    (window as any).ReactNativeWebView.postMessage('logout');
  }
};

const handleServerError = () => {
  if (isServerErrorHandled) return;
  isServerErrorHandled = true;
  toast.error("Server Error");
};


export const addParents = (
  recipient_phone: any,
  institution_vehicle_id: any,
  successCallBack: (message: any) => void,
  errorCallBack: (errorMessage: any) => void
) => {
  const payload = {
    recipient_phone: recipient_phone,
    institution_vehicle_id: institution_vehicle_id,
  };
  axios.post(
    `${global.stms_url}/student_users `,
    payload  )
  .then((response: AxiosResponse) => {
    if (response.status === 201) {
      successCallBack(response);
    } 
    else if (response.status === 200) {
      successCallBack(response);
    } 
  })
  .catch((error: AxiosError) => {
    if (error.response) {
      if (error.response.status === 400) {
        errorCallBack(error?.response?.data);
      } else if (error.response.status === 404){
        errorCallBack(error?.response?.data)
      }
      else if( error.response?.status === 409)
        {
          errorCallBack(error?.response?.data);
        }
      else if (error.response.status === 401) {
        handleUnauthorized();
      }
    } 
    else {
handleServerError();
    }
  });
};
export const getInstitutionVehicleMapping = (
  vehicle_id:number[] | any[],
  driver_id:any,
  per_page_records: any,
  page_number: any,
  _successCallBack: (response: any) => void,
  _errorCallBack: (errMessage: any) => void,
) => {

const requestBody = vehicle_id && vehicle_id.length > 0 ? { vehicle_id: vehicle_id } : {};
  axios
    .get(`${global.stms_url}/institution_vehicles?page_number=${page_number}&per_page_records=${per_page_records}`, { params: { ...requestBody, driver_id: driver_id } })
    .then((response: AxiosResponse) => {
      if (response.status === 200 || response.status === 201) {
        _successCallBack(response.data);
      }
    })
    .catch((error: AxiosError) => {
      if (error.response?.status === 400 || error.response?.status === 404) {
        _errorCallBack(error.response.data);
      } else if (error.response?.status === 401) {
          handleUnauthorized();
      } else {
        handleServerError();
      }
    });
};
export const getParents= (
  institution_vehicle_id:any,
  per_page_records: any,
  page_number: any,
  _successCallBack: (response: any) => void,
  _errorCallBack: (errMessage: any) => void,
) => {

  axios
    .get(`${global.stms_url}/student_users?institution_vehicle_id=${institution_vehicle_id}&page_number=${page_number}&per_page_records=${per_page_records}`)
    .then((response: AxiosResponse) => {
      if (response.status === 200 || response.status === 201) {
        _successCallBack(response.data);
      }
    })
    .catch((error: AxiosError) => {
      if (error.response?.status === 400 || error.response?.status === 404) {
        _errorCallBack(error.response.data);
      } else if (error.response?.status === 401) {
          handleUnauthorized();
      } else {
        handleServerError();
        _errorCallBack(error);
      }
    });
};